import { render, staticRenderFns } from "./EstatusProcesos.view.vue?vue&type=template&id=0f10d786&scoped=true"
import script from "./EstatusProcesos.view.vue?vue&type=script&lang=js"
export * from "./EstatusProcesos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10d786",
  null
  
)

export default component.exports